module.exports = __webpack_public_path__ + "static/media/empty.258afd51.png";